import { render, staticRenderFns } from "./Soal.vue?vue&type=template&id=3a61ee91&scoped=true"
import script from "./Soal.vue?vue&type=script&lang=js"
export * from "./Soal.vue?vue&type=script&lang=js"
import style0 from "./Soal.vue?vue&type=style&index=0&id=3a61ee91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61ee91",
  null
  
)

export default component.exports